import { get, post, put } from '../request'

export const fetchPayment = (id) => get(`api/payments/${id}`)
export const createPayment = (data) => post('api/payments', { data })
export const updatePayment = (id, params) => put(`api/payments/${id}`, params)

export const getApplicationPayments = (application) =>
  get('api/payments', {
    filters: { application },
    pagination: { page: 1, pageSize: 1000 },
  })
